import { useState } from 'react';
import { Box, Button, Dialog as MuiDialog, DialogContent } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import { DialogTitle } from './DialogTitle';
import { useAlerts } from '../hooks/use-alerts';
import { DialogActions } from './DialogActions';

export function Dialog(props) {
  const {
    title,
    titleIcon,
    subTitle,
    onCancel,
    onSave,
    canSave,
    width = 'md',
    children,
    cancelLabel = 'Cancel',
    saveLabel = 'Save',
    actions = true,
    fullScreen,
    ...passThroughProps
  } = props;
  const [isSaving, setSaving] = useState();
  const { showError } = useAlerts();

  return (
    <MuiDialog
      keepMounted
      open
      maxWidth={width}
      fullWidth
      fullScreen={fullScreen}
      PaperProps={
        fullScreen ? { sx: { overflow: 'hidden' } } : { sx: { px: 5, pb: 4 } }
      }
      {...passThroughProps}
    >
      {buildHeader()}
      <DialogContent
        sx={{
          p: 0,
          mb: fullScreen ? 0 : 5,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {children}
      </DialogContent>
      {buildFooter()}
    </MuiDialog>
  );

  async function save(...args) {
    await onSave(...args);
  }

  function buildHeader() {
    return fullScreen ? null : (
      <>
        <Box
          sx={{ backgroundColor: 'primary.main', height: 8, mx: -5, mb: 1.5 }}
        />
        <DialogTitle
          onClose={() => onCancel()}
          title={title}
          titleIcon={titleIcon}
          subTitle={subTitle}
          sx={{ px: 0, mr: -1.5 }}
        />
      </>
    );
  }

  function buildFooter() {
    if (!actions) return null;
    const footerProps = fullScreen
      ? { dark: true, sx: { py: 2, px: 3 } }
      : { sx: { p: 0 } };

    return (
      <DialogActions {...footerProps}>
        {Array.isArray(actions) ? (
          actions
        ) : (
          <>
            {cancelLabel ? (
              <Button
                sx={{ mr: 1 }}
                onClick={() => onCancel()}
                variant="contained"
                color={fullScreen ? 'inherit' : 'dark'}
              >
                {cancelLabel}
              </Button>
            ) : null}
            <LoadingButton
              variant="contained"
              color="primary"
              disabled={!canSave}
              loading={isSaving}
              onClick={(...args) => {
                setSaving(true);
                save(...args)
                  .catch((e) => {
                    showError(e);
                    throw e;
                  })
                  .finally(() => setSaving(false));
              }}
            >
              {saveLabel}
            </LoadingButton>
          </>
        )}
      </DialogActions>
    );
  }
}
